import SEO from "../../components/SEO";

// style
// page components

import browserDetect from "browser-detect";
import SpaceInvadersHero from "../../components/Layout/SpaceInvadersHero";
import useCurrentPage from "../../hooks/useCurrentPage";


// hero image elements
import { triangle } from "../../utils/svgFigures";

import { useGlobalContext } from "../../hooks/useGlobalContext";
import LetterSpanHolder from "../../components/functional/LetterSpanHolder";

// assets
// import mePhoto from "../images/background-image.jpg";
const flagImage = "/images/flag.png";

const HomePage = (props: { children?: any, handlePage: (value: string) => void }) => {
  // assign currentPage
  useCurrentPage(props.handlePage);

  const globalContext = useGlobalContext();
  const homePageContent = globalContext.content.homePage;

  const pageContent = (
    <div className="page-content">
      <SEO
        title="Esteban Lasso"
        description={homePageContent.heroContainer.description}
        url="https://estebanlasso.com/"
      />
      <SpaceInvadersHero
        title="Esteban Lasso"
        description={homePageContent.heroContainer.description}
        location={homePageContent.heroContainer.location}
        flag={flagImage}
        labels={homePageContent.heroContainer.game}
        portrait={browserDetect().mobile === true}
      />
      <section className="messages-section">
        <p className="paragraph-big">
          <LetterSpanHolder string={homePageContent.firstSection.paragraph_big} emphasisIndex={[0, 1, 2]} timeStepinS={2} useWords={true} />
        </p>
        <p className="paragraph-small">
          {homePageContent.firstSection.paragraph_small}
          <span className="span-arrow">{triangle}</span>
        </p>
      </section>

      <section className="experience-section">
        <header className="section-heading">
          <h2 className="section-title">{homePageContent.experienceSection.title}</h2>
          <p className="section-subtitle">{homePageContent.experienceSection.subtitle}</p>
        </header>
        <div className="experience-list">
          {homePageContent.experienceSection.roles.map((role: any, index: number) => (
            <article className="experience-item" key={index}>
              <span className="experience-period">{role.period}</span>
              <div className="experience-body">
                <h3 className="experience-role">
                  {role.role} <span className="experience-company">· {role.company}</span>
                </h3>
                <p className="experience-location">{role.location}</p>
                <p className="experience-description">{role.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="impact-section">
        <header className="section-heading">
          <h2 className="section-title">{homePageContent.impactSection.title}</h2>
          <p className="impact-lead">{homePageContent.impactSection.lead}</p>
        </header>
        <ul className="impact-list">
          {homePageContent.impactSection.points.map((point: any, index: number) => (
            <li className="impact-item" key={index}>
              <span className="impact-highlight">{point.highlight}</span>
              <span className="impact-text">{point.text}</span>
            </li>
          ))}
        </ul>
      </section>

    </div>
  );

  return pageContent;
};

export default HomePage;
